import * as React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
const CdnIcon = ({ icon, className }) => {
    const { CdnIcon: theme } = useTheme('CdnIcon');
    return (React.createElement("svg", { className: cn(theme.root, className), "data-icon": icon },
        React.createElement("use", { xlinkHref: `#${icon}` })));
};
export default CdnIcon;
